import React from "react";
import { useRef, useEffect, useState } from "react";
import { apiURL } from "../../config";
import { useSelector, useDispatch } from "react-redux";
import {
  setConversationId,
  newConversation,
} from "../../redux/conversationIdSlice";
import {
  conversationDelete,
  conversationTitleUpdate,
  conversationStar,
} from "../../redux/conversationsSlice";
import { setMessagesStatus } from "../../redux/messagesStatusSlice";

function Title({ cid, title, star }) {
  const linkRef = useRef(null);
  const titleRef = useRef(null);
  const dotsRef = useRef(null);
  const dropdownRef = useRef(null);
  const conversationId = useSelector((state) => state.conversationId);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [isEditing, setIsEditing] = useState(false);
  const active = conversationId === cid;

  useEffect(() => {
    if (isEditing && titleRef.current) {
      const range = document.createRange();
      range.selectNodeContents(titleRef.current);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }

    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dotsRef.current &&
        !dotsRef.current.contains(event.target)
      ) {
        // 如果不添加contains，点击下拉菜单的时候，在mousedown的一瞬间菜单就会消失，导致无法触发item的click事件
        dropdownRef.current.style.gridTemplateRows = "0fr";
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef, isEditing]);

  const handleTitleClick = (e) => {
    if (cid !== conversationId && !isEditing) {
      dispatch(setConversationId(cid));
      dispatch(setMessagesStatus("LOADING"));
    }
  };

  const handleDotClick = (e) => {
    e.stopPropagation();
    if (dropdownRef.current.style.gridTemplateRows === "1fr") {
      dropdownRef.current.style.gridTemplateRows = "0fr";
    } else {
      dropdownRef.current.style.gridTemplateRows = "1fr";
    }
  };

  const deleteLocalConversation = (cid) => {
    const localConversations = JSON.parse(
      localStorage.getItem("conversations")
    );
    const newConversations = localConversations.filter((c) => c._id !== cid);
    localStorage.setItem("conversations", JSON.stringify(newConversations));
  };

  const renameLocalConversation = (cid, new_title) => {
    const localConversations = JSON.parse(
      localStorage.getItem("conversations")
    );
    const newConversations = localConversations.map((c) => {
      if (c._id !== cid) {
        return c;
      } else {
        return {
          ...c,
          title: new_title,
        };
      }
    });
    localStorage.setItem("conversations", JSON.stringify(newConversations));
  };

  const starLocalConversation = (cid, star) => {
    const localConversations = JSON.parse(
      localStorage.getItem("conversations")
    );
    const newConversations = localConversations.map((c) => {
      if (c._id !== cid) {
        return c;
      } else {
        return {
          ...c,
          star: star,
        };
      }
    });
    localStorage.setItem("conversations", JSON.stringify(newConversations));
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    let url = `${apiURL}/api/conversation/delete/${cid}`;
    try {
      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
      });
      const data = await res.json();
      if (data.message === "success") {
        dispatch(conversationDelete({ _id: cid }));
        if (user.username === "") {
          deleteLocalConversation(cid);
        }
        if (cid === conversationId) {
          dispatch(newConversation());
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleArchive = async (e) => {
    e.stopPropagation();
    let url = `${apiURL}/api/conversation/archive/${cid}`;
    try {
      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
      });
      const data = await res.json();
      if (data.message === "success") {
        dispatch(conversationDelete({ _id: cid }));
        if (cid === conversationId) {
          dispatch(newConversation());
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleRename = async (e) => {
    e.stopPropagation();
    setIsEditing(true);
    //linkRef.current.focus();
    dropdownRef.current.style.gridTemplateRows = "0fr";
  };
  const handleBlur = async () => {
    //console.log('link blur')
    setIsEditing(false);
    let new_title = titleRef.current.innerText;
    //console.log(`new title: ${new_title}`)
    try {
      const response = await fetch(
        `${apiURL}/api/conversation/title-update/${cid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ new_title }),
          credentials: "include",
        }
      );
      const data = await response.json();
      if (data.message === "success") {
        dispatch(
          conversationTitleUpdate({
            _id: cid,
            title: new_title,
          })
        );
        if (user.username === "") {
          renameLocalConversation(cid, new_title);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleStar = async (e) => {
    e.stopPropagation();
    let url = `${apiURL}/api/conversation/star/${cid}`;
    try {
      const res = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ star: !star }),
      });
      const data = await res.json();
      if (data.message === "success") {
        dispatch(conversationStar({ _id: cid, star: !star }));
        if (user.username === "") {
          starLocalConversation(cid, !star);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const tw_bg = active
    ? "border-[1px] border-[hsla(var(--border-100))] bg-[hsla(var(--bg-100))] "
    : "";

  return (
    <li
      key={cid}
      className={
        tw_bg +
        " group/li text-white text-md w-full relative px-2 py-1 mb-1 cursor-pointer rounded hover:bg-[hsla(var(--bg-100))]"
      }
      onClick={(e) => {
        handleTitleClick(e);
      }}
    >
      <span className="relative w-full block">
        {star && <span className="text-yellow-300">★ </span>}
        <span
          ref={linkRef}
          contentEditable={isEditing}
          suppressContentEditableWarning
          onBlur={handleBlur}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              linkRef.current.blur();
            }
          }}
        >
          <span ref={titleRef}>{title}</span>
        </span>
      </span>
      <Dots
        rf={dotsRef}
        handleClick={(e) => {
          handleDotClick(e);
        }}
      />
      <DropDownMenu rf={dropdownRef}>
        <DropDownItem onClick={handleDelete}>Delete</DropDownItem>
        <DropDownItem onClick={handleArchive}>Archive</DropDownItem>
        <DropDownItem onClick={handleRename}>Rename</DropDownItem>
        <DropDownItem onClick={handleStar}>
          {star ? "Unstar" : "Star"}
        </DropDownItem>
      </DropDownMenu>
    </li>
  );
}

function Dots({ rf, handleClick }) {
  return (
    <span
      ref={rf}
      onClick={handleClick}
      className="group/dots absolute hidden group-hover/li:flex right-0 top-0 h-full w-8 bg-inherit items-center justify-center cursor-pointer select-none rounded"
    >
      <span className="group-hover/dots:scale-[1.3]  transition-all duration-100 ">
        ···
      </span>
    </span>
  );
}

function DropDownMenu({ rf, children }) {
  return (
    <span
      className="absolute grid right-0 top-full bg-white w-24 z-10 "
      style={{
        gridTemplateRows: "0fr",
        transition: "grid-template-rows 0.1s ease-out",
      }}
      ref={rf}
    >
      <span className="overflow-hidden">{children}</span>
    </span>
  );
}

function DropDownItem({ onClick, children }) {
  return (
    <div
      className="block text-black text-sm w-full px-2 py-1 cursor-pointer hover:bg-gray-200"
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export default Title;
